import cmsReducer from "./cmsReducer";

export const cmsReducers = {
  cms: cmsReducer,
};
